import { isRTL, URLS } from "@core/shared/utils";
import { Button } from "@design-system/components/Button";
import { BaseLink } from "@design-system/components/link";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@design-system/ui/dropdown-menu";
import { settingsAtom } from "@framework/shared/atoms";
import { useChangeLocaleCode } from "@framework/shared/hooks";
import { GlobeIcon } from "lucide-react";

function LanguageSelector() {
  const { changeLocaleCode } = useChangeLocaleCode();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon">
          <GlobeIcon className="h-5 w-5" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={() => changeLocaleCode("en")}>
          English
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => changeLocaleCode("ar")}>
          العربية
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export function AuthHeader() {
  const rtl = isRTL();
  const general = settingsAtom.use("general");

  return (
    <header className="flex items-center justify-between border-b border-gray-200 dark:border-gray-700 px-8 py-4 bg-white dark:bg-gray-900 transition-colors duration-300">
      <div
        className={`flex items-center gap-4 ${rtl ? "flex-row-reverse" : ""}`}
      >
        <BaseLink to={URLS.home}>
          <img
            src={general?.logo?.url}
            alt={general?.appName}
            className="h-8 w-fit max-w-[120px]"
          />
        </BaseLink>
      </div>
    </header>
  );
}
